import BaseModel from './BaseModel';
import { ReferenceFile } from '@/models';

export default class UploadGroupDto extends BaseModel {
  constructor(data = {}) {
    super(UploadGroupDto, data);
    this.id = data.id;
    this.referenceFiles = data.referenceFiles.map(
      (referenceFile) => new ReferenceFile(referenceFile)
    );
  }

  get researcher() {
    return this.referenceFiles[0].uploadedBy?.researcher ?? null;
  }

  get createdAt() {
    return this.referenceFiles[0].createdAt;
  }
}
